const links = [
	{
		path: '/probono/',
		name: 'Pro Bono',
		active: true,
	},
	{
		path: '/probono/',
		name: 'О проекте',
		active: false,
	},
	{
		path: '/probono/',
		name: 'Условия участия',
		active: false,
	},
	{
		path: '/probono/programmy-skolkovo-pro-bono/',
		name: 'Программы',
		active: true,
	},
	{
		path: '/probono/',
		name: 'Партнеры',
		active: false,
	},
	{
		path: '/probono/',
		name: 'Медиа',
		active: false,
	},
	{
		path: '/probono/',
		name: 'Подать заявку',
		active: false,
	},
];

export default links;
